var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9219 9.96094C19.9219 15.4004 15.4102 19.9219 9.96094 19.9219C4.52148 19.9219 0 15.4004 0 9.96094C0 4.51172 4.51172 0 9.95117 0C15.4004 0 19.9219 4.51172 19.9219 9.96094ZM9.20898 5.5957V10.6055L9.29688 12.7441L8.29102 11.5332L7.09961 10.332C6.96289 10.1855 6.76758 10.1074 6.5625 10.1074C6.14258 10.1074 5.83008 10.4199 5.83008 10.8398C5.83008 11.0547 5.88867 11.2305 6.02539 11.3672L9.38477 14.707C9.58984 14.9121 9.75586 15 9.9707 15C10.1953 15 10.3711 14.9023 10.5664 14.707L13.916 11.3672C14.0527 11.2305 14.1309 11.0547 14.1309 10.8398C14.1309 10.4199 13.8086 10.1074 13.3887 10.1074C13.1738 10.1074 12.9883 10.1758 12.8516 10.332L11.6699 11.5332L10.6445 12.7539L10.7324 10.6055V5.5957C10.7324 5.14648 10.4199 4.83398 9.9707 4.83398C9.53125 4.83398 9.20898 5.14648 9.20898 5.5957Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandArrow);
export default __webpack_public_path__ + "static/media/expand_arrow.88094ce59d43a348d6d66fb77fa98232.svg";
export { ForwardRef as ReactComponent };